import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {NgxPageScrollModule} from 'ngx-page-scroll';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MaterialModalComponent} from '@components/common/modals/material-modal/material-modal.component';
import {MatLegacySlideToggleModule as MatSlideToggleModule} from '@angular/material/legacy-slide-toggle';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import {SearchComponent} from '@components/dw-app/shared/search/search.component';
import {MatLegacyPaginatorModule as MatPaginatorModule} from '@angular/material/legacy-paginator';
import {SearchFilterPipe} from '@pipes/search-filter/search-filter.pipe';
import {SizeCountPipe} from '@pipes/size-count/size-count.pipe';
import {MatLegacyRadioModule as MatRadioModule} from '@angular/material/legacy-radio';
import {
    MAT_LEGACY_SELECT_CONFIG as MAT_SELECT_CONFIG,
    MatLegacySelectModule as MatSelectModule
} from '@angular/material/legacy-select';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MatLegacyTabsModule as MatTabsModule} from '@angular/material/legacy-tabs';
import {ViewSwitcherComponent} from '@components/dw-app/shared/view-switcher/view-switcher.component';
import {PageSizeSwitcherComponent} from '@components/dw-app/shared/page-size-switcher/page-size-switcher.component';
import {SafePipe} from '@pipes/safe-url/safe-url.pipe';
import {NgxPaginationModule} from 'ngx-pagination';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';
import {MatSortModule} from '@angular/material/sort';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatExpansionModule} from '@angular/material/expansion';
import {OverlayModule} from '@angular/cdk/overlay';
import {LocationAutocompleteComponent, OverlayLoaderComponent} from '@components/dw-app/shared';
import {TabsComponent} from '@components/dw-app/shared/tabs/tabs.component';
import {Ng2FlatpickrModule} from 'ng2-flatpickr';
import {CheckValueInArrayPipe} from '@pipes/check-value-in-array/check-value-in-array.pipe';
import {CountDurationPipe} from '@pipes/count-duration/count-duration.pipe';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import {NewUiModalComponent} from '@components/dw-app/shared/new-ui-modal/new-ui-modal.component';
import {
    LocationSliderComponent
} from '@components/marketplace/components/location-slider/location-slider.component';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {ConvertIntoDollarsPipe} from '@pipes/convert-into-dollars/convert-into-dollars.pipe';
import {ImagePreviewComponent} from '@components/marketplace/shared';
import {FindTransactionTypePipe} from '@pipes/find-transaction-type/find-transaction-type.pipe';
import {DeviceActivityPage} from '@components/marketplace/pages/device-activity/device-activity.page';
import {InputRefDirective} from '@components/dw-app/shared/directives/input-ref.directive';
import {UserRoleRestrictionDirective} from '@directives/user-role-restriction.directive';
import {RangeSliderComponent} from '@components/dw-app/shared/range-slider/range-slider.component';
import {MatLegacySliderModule as MatSliderModule} from '@angular/material/legacy-slider';
import {IconTooltipComponent} from '@components/dw-app/shared/icon-tooltip/icon-tooltip.component';
import {InArrayPipe} from '@pipes/in-array-pipe/in-array.pipe';
import {
    TotalPlaylistDurationPipe
} from '@components/dw-app/medias/pipes/total-playlist-duration/total-playlist-duration.pipe';
import {DeleteButtonComponent, DlTabsComponent} from '../../reusable-components';
import {LoaderInButtonDirective} from '@directives/loader-in-button.directive';
import {DlCheckboxComponent} from '../../reusable-components/dl-checkbox/dl-checkbox.component';
import {MatRippleModule} from '@angular/material/core';
import {IsHeaderCheckboxCheckedPipe} from '@pipes/is-header-checkbox-checked.pipe';
import {DotsButtonComponent} from '../../reusable-components/buttons/dots-button/dots-button.component';
import {ModalContainerComponent} from '../../reusable-components/modal-container/modal-container.component';
import {PlaylistSizePipe} from '@components/dw-app/medias/pipes/playlist-size/playlist-size.pipe';
import {CustomMatSortHeaderDirectionDirective} from '@directives/custom-mat-sort-header-direction.directive';
import {AbilityModule} from '@casl/angular';
import {DurationPipe} from '@pipes/timer-duration/duration.pipe';
import {ClampWithTailDirective} from '@directives/clamp-with-tail.directive';
import {MarqueeComponent} from '@components/dw-app/shared/marquee/marquee/marquee.component';
import {ScheduleFormComponent} from '@components/dw-app/shared/schedule-form/schedule-form.component';

const SHARED_MODULES = [
    CommonModule,
    FontAwesomeModule,
    NgxPageScrollModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatSelectModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    MatTabsModule,
    MatTableModule,
    NgxPaginationModule,
    MatSortModule,
    DragDropModule,
    MatMenuModule,
    MatExpansionModule,
    OverlayModule,
    Ng2FlatpickrModule,
    MatProgressSpinnerModule,
    SlickCarouselModule,
    AbilityModule
];

const SHARED_COMPONENTS = [
    MaterialModalComponent,
    SearchComponent,
    ViewSwitcherComponent,
    PageSizeSwitcherComponent,
    TabsComponent,
    LocationAutocompleteComponent,
    NewUiModalComponent,
    OverlayLoaderComponent,
    LocationSliderComponent,
    ImagePreviewComponent,
    DeviceActivityPage,
    RangeSliderComponent,
    IconTooltipComponent,
    DeleteButtonComponent,
    DlCheckboxComponent,
    DotsButtonComponent,
    DlTabsComponent,
    ModalContainerComponent,
    ScheduleFormComponent,
    MarqueeComponent,
];

const SHARED_PIPES: any[] = [
    SearchFilterPipe,
    SizeCountPipe,
    SafePipe,
    CheckValueInArrayPipe,
    CountDurationPipe,
    ConvertIntoDollarsPipe,
    FindTransactionTypePipe,
    InArrayPipe,
    TotalPlaylistDurationPipe,
    IsHeaderCheckboxCheckedPipe,
    PlaylistSizePipe,
    DurationPipe
];

const SHARED_DIRECTIVES: any[] = [
    InputRefDirective,
    UserRoleRestrictionDirective,
    LoaderInButtonDirective,
    CustomMatSortHeaderDirectionDirective,
    ClampWithTailDirective
];

@NgModule({
    imports: [
        ...SHARED_MODULES,
        MatSliderModule,
        MatRippleModule
    ],
    declarations: [
        ...SHARED_COMPONENTS,
        ...SHARED_DIRECTIVES,
        ...SHARED_PIPES,
    ],

    exports: [
        ...SHARED_MODULES,
        ...SHARED_COMPONENTS,
        ...SHARED_DIRECTIVES,
        ...SHARED_PIPES,
    ],
    providers: [
        {
            provide: MAT_SELECT_CONFIG,
            useValue: {overlayPanelClass: 'pager-select'},
        },
    ],
})
export class SharedModule {
}
